const $ = global.jQuery;

const loadingSelector = '#ec-loading';
const spinnerSelector = '.ec-loading__spinner';
let showOnReady = false;
let readyHandlerRegistered = false;

const createSpinner = function() {
    return $('<div>', {
        class: 'ec-loading__spinner',
        role: 'status',
        'aria-live': 'polite',
    }).append(
        $('<span>', {
            class: 'ec-loading__spinnerVisual',
            'aria-hidden': 'true',
        }),
        $('<span>', {
            class: 'ec-loading__text',
            text: '読み込み中です',
        }),
    );
};

const displayLoading = function() {
    const $loading = $(loadingSelector);

    if ($loading.length === 0) {
        return false;
    }

    if ($loading.find(spinnerSelector).length === 0) {
        $loading.append(createSpinner());
    }

    $loading.attr('aria-hidden', 'false').show();

    return true;
};

global.showLoading = function() {
    showOnReady = true;

    if (displayLoading()) {
        showOnReady = false;
        return;
    }

    if (readyHandlerRegistered) {
        return;
    }

    readyHandlerRegistered = true;
    $(function() {
        readyHandlerRegistered = false;
        if (showOnReady && displayLoading()) {
            showOnReady = false;
        }
    });
};

global.hideLoading = function() {
    showOnReady = false;
    $(loadingSelector)
        .attr('aria-hidden', 'true')
        .hide()
        .empty();
};
